import addAhaViewIcon from '../assets/icons/stylusAddAhaView.svg';
import styles from '../styles.module.css';
import { labeledMenuComponent } from '../utils/stylus';
import { svgToIcon } from '../utils/svg';
import Stylus from './Stylus';

export class StylusAddAhaView extends Stylus {
  renderIcon() {
    return svgToIcon(addAhaViewIcon);
  }

  description() {
    return 'Aha! View';
  }

  menuComponent() {
    return labeledMenuComponent(this.renderIcon(), this.description());
  }

  toolButtonClass() {
    return styles.labeledToolButton;
  }

  activate() {
    this.controller.actionSetShowAddAhaViewModal(true);
    // Usually the last-used shape gets activated when someone next clicks on the
    // shape button in the toolbar. For this action we want to go back to the default
    // behaviour of the shape menu once we're done, otherwise clicking on the shape icon
    // will open the modal for adding a view. The user would then have to dismiss the
    // modal to get at the shape menu.
    this.controller.actionSetShapeStylus(this.controller.defaultShapeStylus);
    this.drawingComplete();
  }

  stylusId() {
    return `addAhaView`;
  }
}
